module.exports = __webpack_public_path__ + "img/aniImg1.cb67c094.png";